/* Núvo — reliably open the cart drawer on add-to-cart.
   Observes every /cart/add POST (fetch) and, on success, refreshes the drawer
   contents + count and slides the drawer out. This is independent of
   product-form.js internals / the research PDP's declaration gate, so it works
   for the main Add-to-cart, the sticky bar, quick-adds and the cross-sell. */
(function () {
  'use strict';
  if (window.__nuvoCartOpenInit) return;
  window.__nuvoCartOpenInit = true;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function innerFrom(html, selector) {
    try {
      var el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
      return el ? el.innerHTML : null;
    } catch (e) { return null; }
  }

  var origFetch = window.fetch;

  function refreshAndOpen() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    origFetch(root() + '?sections=cart-drawer,cart-icon-bubble', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data['cart-drawer'] != null) {
          var cd = document.getElementById('CartDrawer');
          var inner = innerFrom(data['cart-drawer'], '#CartDrawer');
          if (cd && inner != null) cd.innerHTML = inner;
        }
        if (data && data['cart-icon-bubble'] != null) {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble) {
            var bi = innerFrom(data['cart-icon-bubble'], '.shopify-section');
            bubble.innerHTML = bi != null ? bi : data['cart-icon-bubble'];
          }
        }
      })
      .catch(function () {})
      .finally(function () {
        var di = drawer.querySelector('.drawer__inner');
        if (di) di.classList.remove('is-empty');
        drawer.classList.remove('is-empty');
        if (typeof drawer.open === 'function') drawer.open();
      });
  }

  // Non-invasively observe cart/add POSTs — we don't touch the request or the
  // response body (product-form.js still reads it); we only react on success.
  window.fetch = function () {
    var url = '';
    try { url = (arguments[0] && arguments[0].url) || arguments[0] || ''; } catch (e) {}
    var opts = arguments[1] || (arguments[0] && typeof arguments[0] === 'object' ? arguments[0] : null);
    var method = (opts && opts.method) || 'GET';
    var isAdd =
      typeof url === 'string' &&
      /\/cart\/add(\.js)?($|\?)/.test(url) &&
      String(method).toUpperCase() === 'POST';

    var promise = origFetch.apply(this, arguments);
    if (isAdd) {
      promise
        .then(function (res) {
          if (res && res.ok) setTimeout(refreshAndOpen, 120);
        })
        .catch(function () {});
    }
    return promise;
  };
})();
